import IconCart from '!svg-react-loader?!images/icons/icon-cart.svg';
import IconClose from '!svg-react-loader?!images/icons/icon-close.svg';

import React from 'react';
import Transition from 'react-transition-group/Transition';
import classNames from 'classnames';

import propTypes from 'propTypes';

const transitionDuration = 300;
const iconClass = 'CartTrigger__icon';
const wrapperDefaultStyle = {
  transition: `transform ${transitionDuration}ms ease-out`,
};

const wrapperStyles = {
  entering: {
    transform: 'scale(1.3)',
  },
  entered: {
    transform: 'scale(1.0)',
  },
  exited: {
    transform: 'scale(1.0)',
  },
};

const quantityDefaultStyle = {
  transition: `opacity ${transitionDuration}ms ease-out`,
};

const quantityStyles = {
  entering: {
    opacity: 1.0,
  },
  entered: {
    opacity: 1.0,
  },
  exiting: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
};

export default class CartIcon extends React.Component {
  state = {
    isPlayingAnimation: true,
  };

  static propTypes = {
    isOpen: propTypes.bool.isRequired,
    totalItems: propTypes.number.isRequired,
  };

  componentWillReceiveProps(nextProps) {
    const totalItemsHaveChanged =
      this.props.totalItems !== nextProps.totalItems;
    if (!nextProps.isOpen && totalItemsHaveChanged) {
      this.setState({
        isPlayingAnimation: false,
        shouldStartAnimation: true,
        totalItemsOrig: this.props.totalItems,
      });
    }
  }

  startAnimationCheck = () => {
    if (this.state.shouldStartAnimation) {
      this.setState({
        isPlayingAnimation: true,
        shouldStartAnimation: false,
      });
    }
  };

  render() {
    const { isPlayingAnimation, totalItemsOrig } = this.state;
    const { totalItems, isOpen } = this.props;

    const displayQuantity = isPlayingAnimation ? totalItems : totalItemsOrig;

    return (
      <Transition
        in={isPlayingAnimation}
        timeout={{ enter: transitionDuration, exit: 200 }}
        onExited={this.startAnimationCheck}
      >
        {status => (
          <div
            className="CartTrigger__inner"
            style={{
              ...wrapperDefaultStyle,
              ...wrapperStyles[status],
            }}
          >
            <IconClose className={classNames(iconClass, 'close-icon')} />
            <IconCart className={classNames(iconClass, 'cart-icon')} />
            <div
              className="CartTrigger__quantity"
              style={{
                ...quantityDefaultStyle,
                ...quantityStyles[status],
              }}
            >
              {displayQuantity}
            </div>
          </div>
        )}
      </Transition>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/CartIcon.js